import { ParticlesOptions } from "../Options/Classes/Particles/ParticlesOptions";
export function loadOptions(options) {
  for (var _len = arguments.length, sourceOptionsArr = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sourceOptionsArr[_key - 1] = arguments[_key];
  }
  for (const sourceOptions of sourceOptionsArr) {
    options.load(sourceOptions);
  }
}
export function loadParticlesOptions(engine, container) {
  const options = new ParticlesOptions(engine, container);
  for (var _len2 = arguments.length, sourceOptionsArr = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    sourceOptionsArr[_key2 - 2] = arguments[_key2];
  }
  loadOptions(options, ...sourceOptionsArr);
  return options;
}